import { Layout } from "antd";
import { FunctionComponent, useContext, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  ROUTE_DASHBOARD_WELCOME,
  ROUTE_PUBLIC_ACCEPT_INVITATION,
  ROUTE_PUBLIC_EXTENSION_INSTALLED,
  ROUTE_PUBLIC_FORGOT_PASSWORD,
  ROUTE_PUBLIC_RESET_PASSWORD,
  ROUTE_PUBLIC_SIGN_IN,
  ROUTE_PUBLIC_SIGN_UP,
} from "../../../shared/app-constants";
import getDashboardRoute from "../../../shared/get-dashboard-route";
import { AppContext } from "../../contexts/app-context";
import PublicLayout from "../../layouts/public-layout";
import AcceptInvitationPage from "../../pages/accept-invitation";
import ExtensionInstalled from "../../pages/extension-installed";
import ForgotPasswordPage from "../../pages/forgot-password-page";
import ResetPasswordPage from "../../pages/reset-password-page";
import SignInPage from "../../pages/sign-in";
import SignUpPage from "../../pages/sign-up";

const { Header, Footer, Sider, Content } = Layout;
interface PublicModuleProps {}

const PublicModule: FunctionComponent<PublicModuleProps> = () => {
  const { user } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const shouldSendToWelcomePage =
      location.pathname.includes(ROUTE_PUBLIC_SIGN_UP) ||
      location.pathname.includes(ROUTE_PUBLIC_ACCEPT_INVITATION.split("/")[0]);
    if (user) {
      const pathname = shouldSendToWelcomePage
        ? getDashboardRoute({}, ROUTE_DASHBOARD_WELCOME)
        : getDashboardRoute({});
      navigate({
        pathname,
      });
    }
  }, [user, navigate]);
  return (
    <PublicLayout>
      <Routes>
        <Route
          path={ROUTE_PUBLIC_EXTENSION_INSTALLED}
          element={<ExtensionInstalled />}
        />
        <Route path={ROUTE_PUBLIC_SIGN_IN} element={<SignInPage />} />
        <Route path={ROUTE_PUBLIC_SIGN_UP} element={<SignUpPage />} />
        <Route
          path={ROUTE_PUBLIC_ACCEPT_INVITATION}
          element={<AcceptInvitationPage />}
        />
        <Route
          path={ROUTE_PUBLIC_FORGOT_PASSWORD}
          element={<ForgotPasswordPage />}
        />
        <Route
          path={ROUTE_PUBLIC_RESET_PASSWORD}
          element={<ResetPasswordPage />}
        />
        <Route
          path="*"
          element={<Navigate to={{ pathname: ROUTE_PUBLIC_SIGN_IN }} />}
        />
      </Routes>
    </PublicLayout>
  );
};

export default PublicModule;
